const logoPaginaDofollow = 'Logo en la página del programa en TNO Network (sección Anunciantes) con enlace dofollow.';

const optionsData = [
  {
    title: 'Sponsorship Después del evento',
    annualPrice: 'Trimestral: 360',
    monthlyPrice: 120,
    features: [
      'Tres menciones en vivo: al entrar, en el desarrollo (aquí se explica tu marca) y salida',
      'Video comercial de 20 segundos durante el programa',
      'Presencia en transmisión en vivo por TNO Network',
      'Presencia en Web, App y Redes Sociales',
      'Asociación con resiliencia, bienestar y periodismo de soluciones',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas de salud mental, bienestar, educación, ONG y servicios con propósito social.',
    duration: 'Mensual',
    buttonText: 'Patrocinar Después del evento',
    highlightedTitle: 'Narrativa con propósito',
    highlightedContent: [
      'Tu marca viaja con Angélica Lugo y Yelitza Yánez.',
      'Tres menciones + un comercial de 20 segundos dentro del programa.',
      'Historias humanas que conectan emocionalmente con la audiencia.',
    ],
    highlightedButtonText: 'Ver Demo del Programa',
  },
  {
    title: 'Segmento Exclusivo por Tema',
    annualPrice: 'Trimestral: 180',
    monthlyPrice: 60,
    features: [
      'Mención exclusiva: "Este segmento presentado por..."',
      'Vinculación con una temática: Resiliencia, Salud mental, Familia o Comunidad',
      'Contenido alineado con el ADN de tu marca',
      'Presencia en el bloque correspondiente del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan relevancia temática en conversaciones de impacto humano.',
    duration: 'Suscripción Mensual',
    buttonText: 'Elegir mi Tema',
    highlightedTitle: 'Autoridad con sensibilidad',
    highlightedContent: [
      'Tu marca se convierte en referente del segmento elegido.',
      'Asociación orgánica con esperanza y superación.',
      'Ideal para campañas de concienciación y servicios.',
    ],
    highlightedButtonText: 'Ver Temas Disponibles',
  },
  {
    title: 'Entrevista Patrocinada',
    annualPrice: 'Por sesión: 40',
    monthlyPrice: 40,
    features: [
      'Entrevista de 20 minutos en vivo',
      'Proyección de tus videos promocionales',
      'Mención de sedes, programas o puntos de contacto',
      'Propuesta con respaldo visual en pantalla',
      'Post en redes sociales del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Fundaciones, coaches, voceros de ONG y marcas con historia de impacto.',
    duration: '20 minutos por sesión',
    buttonText: 'Agendar Entrevista',
    highlightedTitle: 'Tu historia en antena',
    highlightedContent: [
      'Proyección de videos promocionales durante la entrevista.',
      'Narrativa humana con credibilidad periodística.',
    ],
    highlightedButtonText: 'Consultar Fechas',
  },
  {
    title: 'Post Patrocinado en TNO Digest',
    annualPrice: 'Por publicación: 50',
    monthlyPrice: 50,
    features: [
      'Publicación patrocinada en las redes sociales de TNO Digest',
      'Alcance en el ecosistema digital de Después del evento y TNO Digest',
      'Contenido adaptado a bienestar y propósito',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan visibilidad en redes sin compromiso de programa en vivo.',
    duration: 'Por publicación',
    buttonText: 'Solicitar Post Patrocinado',
    highlightedTitle: 'Visibilidad en TNO Digest',
    highlightedContent: [
      'Tu marca en el feed oficial de TNO Digest.',
      'Ideal para campañas de impacto social.',
    ],
    highlightedButtonText: 'Solicitar Post',
  },
  {
    title: 'Cápsula Narrativa / Marca',
    annualPrice: 'Pack 5 Cápsulas: 150',
    monthlyPrice: 40,
    features: [
      'Cápsula de 60-90 segundos con estética del programa',
      'Distribución en redes sociales de TNO y del programa',
      'Tema: resiliencia, testimonio o promoción con propósito',
      'Locución profesional en línea con el tono del show',
      logoPaginaDofollow,
    ],
    idealFor: 'Campañas de concienciación, servicios de acompañamiento y lanzamientos con causa.',
    duration: 'Por cápsula',
    buttonText: 'Solicitar Cápsula',
    highlightedTitle: 'Atención en Redes',
    highlightedContent: [
      'Tu mensaje en el ecosistema de Después del evento.',
      'Formato breve y memorable para máxima recordación.',
    ],
    highlightedButtonText: 'Enviar mi Propuesta',
  },
  {
    title: 'UGC Historias reales',
    annualPrice: '80 por pieza',
    monthlyPrice: 80,
    features: [
      'Video estilo testimonio o historia de superación con el producto o servicio',
      'Demostración en contexto humano y auténtico',
      'Narrativa alineada con resiliencia y bienestar',
      'Publicación del video en TNO y en Después del evento',
      'Entrega de archivo original para pauta publicitaria de la marca',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas de bienestar, educación, salud y organizaciones sin fines de lucro.',
    duration: 'Por pieza',
    buttonText: 'Activar Campaña UGC',
    highlightedTitle: 'Prueba social con alma',
    highlightedContent: [
      'Contenido UGC con tono del programa y credibilidad de las anclas.',
      'Tu marca como acompañante, no como anuncio frío.',
    ],
    highlightedButtonText: 'Activar Campaña UGC',
  },
];

export default optionsData;
